import SalesPopupEventService from './SalesPopupEventService';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const SalesPopupService = {
  async getActivePopup() {
    try {
      const response = await fetch(`${API_BASE_URL}/sales-popup/active/`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching active sales popup:', error);
      throw error;
    }
  },

  async createLead(leadData) {
    try {
      // Obtener session ID para trackear la conversión
      const sessionId = sessionStorage.getItem('sales_popup_session_id');
      const timeOnPage = SalesPopupEventService.getTimeOnPage();
      const scrollDepth = SalesPopupEventService.getScrollDepth();
      
      const response = await fetch(`${API_BASE_URL}/sales-popup/lead/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...leadData,
          session_id: sessionId,
          time_on_page: timeOnPage,
          scroll_depth: scrollDepth,
        }),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || 'Failed to create lead. Please try again.');
      }
      return data;
    } catch (error) {
      console.error('Error creating sales popup lead:', error);
      throw error;
    }
  },
};

export default SalesPopupService;

